import useCurrentShowId from "hooks/useCurrentShowId";
import { useEffect, useMemo } from "react";
import { useRefundStoreActions } from "store/refund/refund.store";
import Order from "ts/api/order";
import { RefundStatus } from "@evennt-tech/api-v2-core";

type Params = {
  supplierCompanyId?: string;
  orders?: Order[];
  isReady?: boolean;
};

export const useFetchRefunds = ({
  supplierCompanyId,
  orders,
  isReady = true,
}: Params) => {
  const showId = useCurrentShowId();
  const { fetchRefunds } = useRefundStoreActions();

  const orderIds = useMemo(() => {
    if (!orders?.length) {
      return [];
    }
    return orders.map((o) => o.id);
  }, [orders]);

  useEffect(() => {
    if (!showId || !orderIds.length || !isReady) {
      return;
    }

    const statuses: RefundStatus[] = [
      RefundStatus.Processing,
      RefundStatus.Processed,
    ];
    if (supplierCompanyId) {
      statuses.push(RefundStatus.Failed);
      statuses.push(RefundStatus.InReview);
    }
    fetchRefunds({
      showId,
      orderIds,
      ...(supplierCompanyId && { supplierCompanyId }),
      statuses,
    });
    // NOTE: Change dependency from orderIds.length to orderIds when orders pagination is added
  }, [showId, orderIds.length, supplierCompanyId, isReady]);
};
